export default __webpack_public_path__ + "assets/MicrogrammaD-BoldExte.5d56e26d.svg";